"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeaheadSearchInput = void 0;
var storm_ui_1 = require("@amzn/storm-ui");
var react_1 = __importStar(require("react"));
var typeahead_search_input_styles_1 = require("./typeahead_search_input.styles");
var debounced_state_1 = require("../util/debounced_state");
var renderSuggestion = function (suggestion) {
    var parts = suggestion.split(/(<em>|<\/em>)/g);
    var isEmphasized = false;
    return parts.map(function (part, index) {
        if (part === '<em>') {
            isEmphasized = true;
            return '';
        }
        if (part === '</em>') {
            isEmphasized = false;
            return '';
        }
        return isEmphasized ? react_1.default.createElement("strong", { key: index }, part) : part;
    });
};
var getSuggestionValue = function (suggestion) { return suggestion.replace(/(<em>|<\/em>)/g, ''); };
exports.TypeaheadSearchInput = (0, react_1.memo)(function TypeaheadSearchInput(props) {
    var _a, _b;
    var updateSearchQuery = props.updateSearchQuery, searchQuery = props.searchQuery, fetchSuggestions = props.fetchSuggestions, isRtl = props.isRtl, isMobile = props.isMobile, mobileHeaderOffset = props.mobileHeaderOffset, placeholder = props.placeholder, clearButtonLabel = props.clearButtonLabel, fullWidth = props.fullWidth, id = props.id, label = props.label, waitInterval = props.waitInterval, maxLength = props.maxLength;
    var _c = (0, react_1.useState)(searchQuery), fieldValue = _c[0], setFieldValue = _c[1];
    var _d = (0, react_1.useState)([]), suggestions = _d[0], setSuggestions = _d[1];
    var _e = (0, react_1.useState)(false), focused = _e[0], setFocused = _e[1];
    var _f = (0, react_1.useState)(-1), highlightedIndex = _f[0], setHighlightedIndex = _f[1];
    var showSuggestions = focused && suggestions.length > 0;
    var anchorRef = (0, react_1.useRef)(null);
    var updateSuggestions = function (query) {
        var trimmedQuery = query.trim();
        if (trimmedQuery.length > 1) {
            fetchSuggestions(trimmedQuery).then(setSuggestions);
        }
        else {
            setSuggestions([]);
        }
        setHighlightedIndex(-1);
    };
    var _g = (0, debounced_state_1.useDebouncedState)(searchQuery, updateSuggestions, waitInterval), inputValue = _g[0], setInputValue = _g[1];
    var handleKeyDown = (0, react_1.useCallback)(function (event) {
        if ((event === null || event === void 0 ? void 0 : event.key) === storm_ui_1.keyboardKeyNames.ENTER) {
            event.preventDefault();
            updateSearchQuery(fieldValue, highlightedIndex !== -1);
            setSuggestions([]);
        }
        else if ((event === null || event === void 0 ? void 0 : event.key) === storm_ui_1.keyboardKeyNames.ARROW_DOWN) {
            event.preventDefault();
            setHighlightedIndex(function (prevIndex) {
                var newIndex = prevIndex < suggestions.length - 1 ? prevIndex + 1 : -1;
                var newValue = getSuggestionValue(newIndex === -1 ? inputValue : suggestions[newIndex]);
                setFieldValue(newValue);
                return newIndex;
            });
        }
        else if ((event === null || event === void 0 ? void 0 : event.key) === storm_ui_1.keyboardKeyNames.ARROW_UP) {
            event.preventDefault();
            setHighlightedIndex(function (prevIndex) {
                var newIndex = prevIndex > -1 ? prevIndex - 1 : suggestions.length - 1;
                var newValue = getSuggestionValue(newIndex === -1 ? inputValue : suggestions[newIndex]);
                setFieldValue(newValue);
                return newIndex;
            });
        }
    }, [fieldValue, suggestions, inputValue, updateSearchQuery]);
    var mobileScrollHandler = function () {
        if (isMobile && anchorRef.current && mobileHeaderOffset) {
            var searchBarTop = anchorRef.current.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({ top: searchBarTop - mobileHeaderOffset, behavior: 'smooth' });
        }
    };
    var handleInputChange = function (event) {
        if (event && event.target) {
            mobileScrollHandler();
            var input = event.target.value || '';
            setFieldValue(input);
            setInputValue(input);
        }
    };
    var handleInputClear = function () {
        setFieldValue('');
        setInputValue('');
        updateSearchQuery('', false);
        setSuggestions([]);
    };
    var handleSelect = function (suggestion) {
        var suggestionValue = getSuggestionValue(suggestion);
        setFieldValue(suggestionValue);
        setInputValue(suggestionValue);
        updateSearchQuery(suggestionValue, true);
        setSuggestions([]);
    };
    var handleFocus = function () {
        setFocused(true);
        mobileScrollHandler();
    };
    return (react_1.default.createElement(typeahead_search_input_styles_1.TypeaheadSearchContainer, { onKeyDown: handleKeyDown, ref: anchorRef },
        react_1.default.createElement(storm_ui_1.SearchInput, { id: (0, storm_ui_1.useUID)(id || 'quick-search-input'), placeholder: placeholder, value: fieldValue, onBlur: function () { return setFocused(false); }, onFocus: handleFocus, onClear: handleInputClear, onChange: handleInputChange, fullWidth: fullWidth, clearButtonLabel: clearButtonLabel, label: label, maxLength: maxLength, autoComplete: "off" }),
        react_1.default.createElement(typeahead_search_input_styles_1.TypeaheadPopover, { isOpen: showSuggestions, withBackdrop: true, position: "bottom", align: "start", offset: {
                x: (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.offsetLeft,
                y: (_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.offsetTop,
            }, disableFlip: true, anchorEl: anchorRef.current, width: anchorRef.current ? anchorRef.current.clientWidth : 0, isRtl: isRtl },
            react_1.default.createElement(storm_ui_1.SelectList, null,
                react_1.default.createElement(typeahead_search_input_styles_1.InvisibleSuggestionOption, { key: "suggestion-default", value: inputValue, onClick: function () { return handleSelect(inputValue); } }),
                suggestions.map(function (suggestion, index) { return (react_1.default.createElement(typeahead_search_input_styles_1.SuggestionOption, { key: "suggestion-".concat(index), value: suggestion, onClick: function () { return handleSelect(suggestion); }, selected: highlightedIndex === index },
                    react_1.default.createElement(storm_ui_1.Icon, { type: "search", size: "sm" }),
                    react_1.default.createElement(typeahead_search_input_styles_1.SuggestionText, null, renderSuggestion(suggestion)))); })))));
});
